// UI3
import Modal from 'ui3/Modal/Modal';
import Button from 'ui3/Button/Button';
// Styles
import styles from './UnlinkSocialAccountDialog.module.scss';

type UnlinkSocialAccountDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
};

const UnlinkSocialAccountDialog = ({
  isOpen,
  onClose,
  onConfirm,
  loading = false,
}: UnlinkSocialAccountDialogProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      closeOnOverlayClick={!loading}
      title="Unlink social account?"
      subTitle="This will disconnect the account from your profile. You can reconnect it anytime."
      size="small"
    >
      <div className={styles.actions}>
        <Button variant="error" onClick={onConfirm} block loading={loading}>
          Yes, unlink
        </Button>
        <Button variant="secondary" onClick={onClose} block disabled={loading}>
          No, keep it
        </Button>
      </div>
    </Modal>
  );
};

export default UnlinkSocialAccountDialog;
